<template>
  <v-container>
    Edit Profile Page test
  </v-container>
</template>

<script>
export default {
  name: 'EditProfilePage',
};
</script>
